export default __webpack_public_path__ + "static/media/tail-zoomed.87c5f3e7.svg";